import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
const BannerProductionNotice = ({ isPro, isLicensed, isDevLicense, i18n: { noLicense, devLicense, devLicenseLearnMore, devLicenseLink } })=>{
    if (!isPro) {
        return null;
    }
    const style = {
        fontSize: 13,
        color: "#c95252",
        fontWeight: "bold",
        order: 9
    };
    let useText = "";
    if (isDevLicense) {
        useText = devLicense;
    } else if (!isLicensed) {
        useText = noLicense;
    }
    return useText ? /*#__PURE__*/ _jsxs("div", {
        style: style,
        children: [
            useText,
            isDevLicense && /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    " (",
                    /*#__PURE__*/ _jsx("a", {
                        href: devLicenseLink,
                        rel: "noreferrer",
                        target: "_blank",
                        style: style,
                        children: devLicenseLearnMore
                    }),
                    ")"
                ]
            })
        ]
    }) : null;
};
export { BannerProductionNotice };
